import get from "lodash/get";

export function getItemErrors(itemErrors, itemId) {
  return itemErrors
    ? itemErrors.filter((error) => get(error, "extra_info.item.uuid") === itemId)
    : [];
}
